import { useAppStore } from "@/store/app/slice";
import { UserRole } from "@/types/users";

export const useUserRole = () => {
  const user = useAppStore((s) => s.user);

  return {
    isAdmin: user?.role === UserRole.Admin,
    isContractor: user?.role === UserRole.Contractor,
    isInspector: user?.role === UserRole.Inspector,
    isClient: user?.role === UserRole.Client,
    isSuperAdmin: user?.role === UserRole.SuperAdmin,
    isLoanOfficer: user?.role === UserRole.LoanOfficer,
    isLoanProcessor: user?.role === UserRole.LoanProcessor,
    isProjectManager: user?.role === UserRole.ProjectManager,
  };
};
